import PivotGridRowProps from './Rows'
import Vue from 'vue'

let KendoPivotGridRow = {
    name: 'kendo-pivot-row',
    render () {
        return Vue.prototype._e
    },
    mixins: [PivotGridRowProps]
}

export default KendoPivotGridRow


// WEBPACK FOOTER //
// ./packages/kendo-datasource-vue-wrapper/src/KendoPivotRow/index.js